module.exports = __webpack_public_path__ + "img/hr-brown-fluff-07.0ab1154a.png";